import moment from 'moment'
import { v4 as uuid } from 'uuid'
import {
  fetchWithToken,
} from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const PlateauService = {
  getPlateauById(idPlateau) {
    const filter = JSON.stringify([{ 'field': '_id', 'operator': '=', 'value': idPlateau }])
    return fetchWithToken(`${config().syncService}/plateaux?filters=${filter}`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getPlateaux() {
    return fetchWithToken(`${config().syncService}/plateaux`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getProductAnnex() {
    return fetchWithToken(`${config().syncService}/productAnnex`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getRemovedPlateaux() {
    return fetchWithToken(`${config().syncService}/plateaux?deleted=true`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getPlateauCount() {
    return fetchWithToken(`${config().syncService}/plateaux`, {
      method: 'GET',
    }).then((response) => response.json())
      .then((plateaux) => plateaux.length)
  },
  getPlateauType() {
    return fetchWithToken(`${config().syncService}/plateauProductType`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  reassign(plateau) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    return fetchWithToken(`${config().syncService}/plateaux`, {
      method: 'PUT',
      body: JSON.stringify([{ ...plateau, lastUpdate, deleted: false }]),
    }).then((body) => body.json())
      .then(() => ({
        ...plateau,
        lastUpdate,
        deleted: false,
      }))
  },
  upsertType(productType) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    return fetchWithToken(`${config().syncService}/plateauProductType`, {
      method: 'PUT',
      body: JSON.stringify([{ ...productType, lastUpdate }]),
    }).then((body) => body.json())
      .then(() => ({
        ...productType,
        lastUpdate,
      }))
  },
  upsert(plateau) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const plateauUUid = uuid()
    if (!plateau._id) {
      const finalPlateau = {
        ...plateau,
        _id: plateauUUid,
        lastUpdate,
        deleted: false,
      }
      return fetchWithToken(`${config().syncService}/plateaux`, {
        method: 'PUT',
        body: JSON.stringify([finalPlateau]),
      }).then((body) => body.json())
        .then(() => ({
          ...finalPlateau,
          lastUpdate,
        }))
    }
    return fetchWithToken(`${config().syncService}/plateaux`, {
      method: 'PUT',
      body: JSON.stringify([{ ...plateau, lastUpdate }]),
    }).then((body) => body.json())
      .then(() => ({
        ...plateau,
        lastUpdate,
      }))
  },
}
